import { usePwaInstall } from '../../hooks/usePwaInstall';

const cardStyle = {
  margin: '0 0.75rem 0.75rem',
  padding: '12px',
  borderRadius: 12,
  background: 'rgba(108,99,255,0.12)',
  border: '1px solid rgba(108,99,255,0.25)',
};

const btnPrimary = {
  flex: 1,
  padding: '8px 10px',
  borderRadius: 8,
  border: 'none',
  background: '#6C63FF',
  color: '#fff',
  fontSize: 12,
  fontWeight: 600,
  cursor: 'pointer',
};

const btnGhost = {
  padding: '8px 10px',
  borderRadius: 8,
  border: '1px solid rgba(255,255,255,0.12)',
  background: 'transparent',
  color: 'rgba(255,255,255,0.5)',
  fontSize: 12,
  cursor: 'pointer',
};

function IosHelpModal({ onClose, onDismiss }) {
  return (
    <div
      role="dialog"
      aria-labelledby="pwa-ios-title"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        background: 'rgba(0,0,0,0.65)',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        padding: '1rem',
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 400,
          background: '#1a1a2e',
          borderRadius: 20,
          padding: '1.5rem',
          border: '1px solid rgba(255,255,255,0.1)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="pwa-ios-title" style={{ color: '#fff', fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
          Add to Home Screen
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14, lineHeight: 1.5, marginBottom: '1.25rem' }}>
          Install ABGA Dashboard like an app on your iPhone or iPad:
        </p>
        <ol style={{ color: 'rgba(255,255,255,0.75)', fontSize: 14, lineHeight: 1.7, paddingLeft: '1.25rem', marginBottom: '1.25rem' }}>
          <li>Tap the <strong>Share</strong> button in Safari (square with arrow up).</li>
          <li>Scroll and tap <strong>Add to Home Screen</strong>.</li>
          <li>Tap <strong>Add</strong> to confirm.</li>
        </ol>
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" style={btnPrimary} onClick={onClose}>
            Got it
          </button>
          <button type="button" style={btnGhost} onClick={onDismiss}>
            Don&apos;t show again
          </button>
        </div>
      </div>
    </div>
  );
}

export default function InstallAppPrompt() {
  const {
    shouldShowPrompt,
    canNativeInstall,
    canShowIosHint,
    showIosHelp,
    install,
    openIosHelp,
    closeIosHelp,
    dismiss,
  } = usePwaInstall();

  if (!shouldShowPrompt && !showIosHelp) return null;

  const handleInstall = async () => {
    if (canNativeInstall) {
      await install();
      return;
    }
    if (canShowIosHint) {
      openIosHelp();
    }
  };

  return (
    <>
      {shouldShowPrompt && (
        <div style={cardStyle}>
          <p style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.35)', letterSpacing: '0.08em', marginBottom: 6 }}>
            INSTALL APP
          </p>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.65)', lineHeight: 1.45, marginBottom: 10 }}>
            {canNativeInstall
              ? 'Open ABGA from your home screen — works offline after first load.'
              : 'Add ABGA to your home screen for quick access like a native app.'}
          </p>
          <div style={{ display: 'flex', gap: 6 }}>
            <button type="button" style={btnPrimary} onClick={handleInstall}>
              {canNativeInstall ? 'Install app' : 'How to install'}
            </button>
            <button type="button" style={btnGhost} onClick={dismiss} aria-label="Dismiss install prompt">
              ✕
            </button>
          </div>
        </div>
      )}

      {showIosHelp && (
        <IosHelpModal onClose={closeIosHelp} onDismiss={dismiss} />
      )}
    </>
  );
}
